module.exports = __webpack_public_path__ + "img/home-1.9e99bb9f.png";